import { Action, ActionReducer } from '@ngrx/store';
import { ParameterValues } from '../../../data-entry/models/parameters.type';
import { ParameterValuesAction, ParameterValuesActionType } from '../../actionstypes/parameter-values/parameter-values.actiontype';

const initialState: ParameterValues = {};

const parameterValuesReducer = (state = initialState, action: ParameterValuesActionType): ParameterValues => {
  switch (action.type) {
    case ParameterValuesAction.Set: {
      const { query, value } = action.payload;
      const id = state[query] && state[query].id ? state[query].id : value.id || null;
      return {
        ...state,
        [query]: { ...value, id, hasError: false },
      };
    }

    case ParameterValuesAction.UpdateId: {
      const { query, id, status } = action.payload;
      return {
        ...state,
        [query]: { ...state[query], id, status },
      };
    }

    case ParameterValuesAction.DeleteId: {
      const { query } = action.payload;

      const newState = { ...state };
      delete newState[query];

      return newState;
    }

    case ParameterValuesAction.Reset:
      return {};

    case ParameterValuesAction.UpdateError: {
      const { query, hasError } = action.payload;
      return {
        ...state,
        [query]: { ...state[query], hasError },
      };
    }
    default:
      return state;
  }
};

export default parameterValuesReducer as ActionReducer<ParameterValues, Action<string>>;
